import React, { useEffect, useState, useContext } from "react";
import { Layout, Menu, Spin, message } from "antd";
import logo from "../../../Assets/logo.gif";
import { Link } from "react-router-dom";
import {
  DashboardOutlined,
  ShoppingCartOutlined,
  UploadOutlined,
  AppstoreOutlined,
  CustomerServiceOutlined,
  UserOutlined,
  LogoutOutlined,
} from "@ant-design/icons";
import axios from "axios";
import SummaryApi from "../../../common/index";
import Workspace from "./Workspace";
import { UserContext } from "../../../context/UserContext";
import "../../../Styles/SellerStylings/Sellerdashboard.css";
 
const { Header, Sider, Content } = Layout;
const { SubMenu } = Menu;
 

function SellerDashboard() {
  const { user } = useContext(UserContext);
  const [seller, setSeller] = useState(null);
  const [loading, setLoading] = useState(true);
  const [collapsed, setCollapsed] = useState(false);
  const [editProduct, setEditProduct] = useState(null);
  const [activeTab, setActiveTab] = useState("profile");
 
 
  const toggleSidebar = () => {
  const sidebar = document.querySelector(".seller-sidebar");
  sidebar.classList.toggle("open");
};
  useEffect(() => {
    if (!user || user.role?.toLowerCase() !== "seller") {
      window.location.href = "/seller-signin";
      return;
    }
 
    const fetchSeller = async () => {
      try {
        const token = localStorage.getItem("token");
        const res = await axios.get(SummaryApi.sellerDashboard.url, {
          headers: { Authorization: `Bearer ${token}` },
        });
        setSeller(res.data.seller);
      } catch (err) {
        message.error(err.response?.data?.message || "Failed to fetch seller data");
        window.location.href = "/seller-signin";
      } finally {
        setLoading(false);
      }
    };
 
    fetchSeller();
  }, [user]);
 
  if (loading) return <Spin tip="Loading Dashboard..." style={{ marginTop: 50 }} />;
  if (!seller) return <p>Failed to load seller data.</p>;
 
  return (
    
    <Layout className="seller-dashboard-layout">
      {/* Sidebar */}
      <Sider
        collapsible
        collapsed={collapsed}
        onCollapse={(value) => setCollapsed(value)}
        className="seller-sidebar"
        width={230}
      >
        <div className="logo-area">
         <Link to="/">
            <img src={logo} alt="logo" style={{ width: "185px", marginTop: "-0px", marginLeft:"-15px" ,padding:"2px"}}/>
          </Link>
        </div>
 
       <Menu
  theme="dark"
  mode="inline"
  defaultSelectedKeys={["profile"]}
  onClick={({ key }) => {
    setActiveTab(key);

    // Close sidebar automatically on mobile
    if (window.innerWidth <= 768) {
      setCollapsed(true); // collapse the Ant Design sidebar
      const sidebar = document.querySelector(".seller-sidebar");
      sidebar.classList.remove("open"); // remove 'open' class for sliding menu
    }
  }}
  style={{ fontSize: "15px", background: "#1129ce" }}
>

          <Menu.Item key="profile" icon={<UserOutlined />}>
            Profile
          </Menu.Item>
 
          <Menu.Item key="uploadProduct" icon={<UploadOutlined />}>
            Upload Product
          </Menu.Item>
 
          <Menu.Item key="products" icon={<AppstoreOutlined />}>
            Product List
          </Menu.Item>
 
          <SubMenu key="orders" icon={<ShoppingCartOutlined />} title="Orders" >
            <Menu.Item key="orders-main">Orders</Menu.Item>
            <Menu.Item key="returns">Return Orders</Menu.Item>
            <Menu.Item key="cancelled">Cancelled Orders</Menu.Item>
            <Menu.Item key="paymentPending">Payment Pending</Menu.Item>
            <Menu.Item key="shipped">Completed Orders</Menu.Item>
          </SubMenu>
 <SubMenu key="support" icon={<CustomerServiceOutlined />} title="Support">
  <Menu.Item key="queries-raised">My Queries</Menu.Item>

</SubMenu>

 
          <Menu.Item key="logout" icon={<LogoutOutlined />} onClick={() => {
            localStorage.removeItem("token");
            window.location.href = "/seller-signin";
          }}>
            Logout
          </Menu.Item>
        </Menu>
      </Sider>
 
      {/* Main Content Area */}
      <Layout>
<Header className="seller-header" onClick={toggleSidebar}>
  <h2>Seller Dashboard</h2>
  <span className="seller-name">
    <UserOutlined style={{ marginRight: "8px", fontSize: "18px", color: "#1129ce" }} />
    Welcome, <strong>{seller.storeName || seller.name}</strong>
  </span>
</Header>

 
        <Content className="seller-content">
          <div className="workspace-container">
            <Workspace activeTab={activeTab} seller={seller} token={localStorage.getItem("token")}editProduct={editProduct}
  setEditProduct={setEditProduct}    setActiveTab={setActiveTab}
 />
          </div>
        </Content>
      </Layout>
    </Layout>
  );
}
 
export default SellerDashboard;